import React from 'react'
import GramSlider from '../components/GramSlider'

const Gram = () => {
  return (
    <GramSlider/>
  )
}

export default Gram